import { FC } from "react";
import "./style.scss";
import { VerificationBtn } from "../components/button";
import IdColored from "../../../../assets/verification/IdColored.svg";
import IdColoredVelar from "../../../../assets/velar/IdColoredVelar.svg";
import { ReactComponent as IdentityProof } from "../../../../assets/verification/IdentityProof.svg";
import { ReactComponent as MarketExperience } from "../../../../assets/verification/MarketExperience.svg";
import { ReactComponent as PersonalInfo } from "../../../../assets/verification/PersonalInfo.svg";
import { ReactComponent as CompanyDetails } from "../../../../assets/verification/CompanyDetails.svg";
import { PATH_LIST } from "shared/lib/react-router";
import { useStore } from "zustand";
import { KYC_Step } from "entities/account";
import { useVerificationStep } from "hooks/useVerificationStep";
import { sessionStore } from "entities/session/model/sessionModel";
import { EntityType, IsVelarApp, SvgIcon } from "static/types";
import { useTranslation } from "react-i18next";

type PropsType = {
  text: string;
  icon: SvgIcon;
};

const WelcomeField: FC<PropsType> = ({ text, icon: Icon }) => {
  return (
    <div className="verification-welcome-field">
      <Icon className="verification-welcome-field-icon" aria-hidden />
      <p>{text}</p>
    </div>
  );
};

type FieldConfig = {
  text: string;
  icon: SvgIcon;
};

const welcomeFieldsByEntity: Record<EntityType, FieldConfig[]> = {
  [EntityType.Individual]: [
    { text: "personalInfo", icon: PersonalInfo },
    { text: "marketExperience", icon: MarketExperience },
    { text: "proofOfIdentity", icon: IdentityProof },
  ],
  [EntityType.Entity]: [
    { text: "yourCompanyDetails", icon: CompanyDetails },
    { text: "validBusinessDocuments", icon: IdentityProof },
  ],
};

export const WelcomePage = () => {
  const { t } = useTranslation("onboarding");
  const { t: o } = useTranslation("onboarding-auth");
  const { entity, user } = useStore(sessionStore);
  const nextStep =
    entity === EntityType.Individual
      ? user?.isEmailVerified
        ? user?.isPhoneVerified
          ? PATH_LIST.uploadCredentials
          : PATH_LIST.phoneNumber
        : PATH_LIST.email
      : PATH_LIST.details;
  const { isLoading, onSubmit } = useVerificationStep<KYC_Step.None>({
    step: KYC_Step.None,
    navigateOnSuccess: nextStep,
  });

  const fields = welcomeFieldsByEntity[entity];

  return (
    <div className="verification-welcome">
      <div className="verification-welcome-main">
        <div className="verification-welcome-top-wrapper">
          <img
            src={IsVelarApp ? IdColoredVelar : IdColored}
            alt={IsVelarApp ? "IdColoredVelar" : "IdColored"}
          />
          <p>{IsVelarApp ? t("welcomeVelar") : t("welcomeSirius")}</p>
          <span>{t("quickSetup")}</span>
        </div>

        <div className="verification-welcome-field-wrapper">
          {fields.map(({ text, icon }) => (
            <WelcomeField key={text} text={t(text)} icon={icon} />
          ))}
        </div>

        <p className="we-are-required">{t("requiredByLaw")}</p>
      </div>
      <VerificationBtn
        disabled={isLoading}
        onClick={() => onSubmit({})}
        text={o("getStarted")}
      />
    </div>
  );
};

//  *  old translates  *

// "needBreak": "Need a break?",
// "progressSaved": "Your information will be saved, so you can pick up right where you left off.",
// "saveAndLeave": "Save Progress",
// "keepGoing": "Keep Going",

// "needBreak": "Сделать паузу?",
// "progressSaved": "Мы сохраним прогресс. Возвращайтесь, когда будете готовы.",
// "saveAndLeave": "Сохранить прогресс",
// "keepGoing": "Продолжить",

// "needBreak": "Ցանկանում եք դուրս գալ՞",
// "progressSaved": "Մենք կպահպանենք Ձեր տվյալները: Վերադարձեք, երբ պատրաստ լինեք",
// "saveAndLeave": "Պահպանել",
// "keepGoing": "Շարունակել",
